import { cn } from '../utlis/cn'
import './circle-icon.css'

type DashButtonIconProps = {
    className?: string
    children?: React.ReactNode
    light?: boolean
    glowColor?: string
    pulse?: boolean
}

export function IconCircle({ className, children, light, pulse, glowColor = 'white' }: DashButtonIconProps) {
    const hover = 'transition-transform duration-150 group-hover:scale-110'
    const layout = 'flex items-center justify-center'
    const border = light ? 'rounded-[60px] border border-white/40' : 'rounded-[60px] border border-white/10'
    const bg = light ? 'shadow-[inset_2px_4px_16px_0px_rgba(255,255,255,0.3)]' : 'shadow-glow'

    return (
        <div className={cn(hover, 'relative rounded-[60px] overflow-clip', pulse && 'pulse', className)}>
            <div
                className={cn('absolute rounded-[60px] bottom-1 left-5 right-5 h-[5px]', 'blur-md', `bg-${glowColor}`)}
            ></div>
            <div className={cn('w-full h-full', layout, border, bg)}>{children}</div>
        </div>
    )
}
